module.exports = __webpack_public_path__ + "31557c5eb8bac0dbf9067b2ed6ae9f7f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-zip.png
// module id = Ffi5
// module chunks = 5